/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
    fixPivot(scene.textures.get("chest-1-2"), "", ChestShut12AnimationData.frames);
    fixPivot(scene.textures.get("chest-3-4"), "", ChestShut34AnimationData.frames);
    fixPivot(scene.textures.get("chest-5"), "", ChestShut5AnimationData.frames);
    fixPivot(scene.textures.get("chest-6"), "", ChestShut6AnimationData.frames);
    fixPivot(scene.textures.get("chest-7-8"), "", ChestShut78AnimationData.frames);
    fixPivot(scene.textures.get("chest-9-10"), "", ChestShut910AnimationData.frames);
    fixPivot(scene.textures.get("sharkBite"), "", SharkAnimationData.frames);

    createAnimation(scene.anims, "sharkBite", "Bite", SharkAnimationData.animations.Bite.frames);
    createAnimation(scene.anims, "sharkBite", "Idle", SharkAnimationData.animations.Idle.frames);
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
    frameData.forEach((data, index) => {
        let frame = texture.get(prefix + index);
        frame.customPivot = true;
        frame.pivotX = data[5] / data[2];
        frame.pivotY = data[6] / data[3];
    });
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 * @param {string} texture 
 */
export function addAnimations(sprite, texture) {
    let animationData = null;
    switch (texture) {
        case "chest-1-2": animationData = ChestShut12AnimationData.animations.Shut.frames; break;
        case "chest-3-4": animationData = ChestShut34AnimationData.animations.Shut.frames; break;
        case "chest-5": animationData = ChestShut5AnimationData.animations.Shut.frames; break;
        case "chest-6": animationData = ChestShut6AnimationData.animations.Shut.frames; break;
        case "chest-7-8": animationData = ChestShut78AnimationData.animations.Shut.frames; break;
        case "chest-9-10": animationData = ChestShut910AnimationData.animations.Shut.frames; break;
    }
    let frames = [];
    animationData.forEach(frameNum => frames.push({ frame: frameNum.toString() }));
    sprite.anims.create(
        {
            defaultTextureKey: texture,
            frameRate: 24,
            key: "Shut",
            frames: frames
        });

    sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + "Shut", () => sprite.play("Idle"));

    animationData = null;
    switch (texture) {
        case "chest-1-2": animationData = ChestShut12AnimationData.animations.Idle.frames; break;
        case "chest-3-4": animationData = ChestShut34AnimationData.animations.Idle.frames; break;
        case "chest-5": animationData = ChestShut5AnimationData.animations.Idle.frames; break;
        case "chest-6": animationData = ChestShut6AnimationData.animations.Idle.frames; break;
        case "chest-7-8": animationData = ChestShut78AnimationData.animations.Idle.frames; break;
        case "chest-9-10": animationData = ChestShut910AnimationData.animations.Idle.frames; break;
    }
    frames = [];
    animationData.forEach(frameNum => frames.push({ frame: frameNum.toString() }));

    sprite.anims.create(
        {
            defaultTextureKey: texture,
            frameRate: 24,
            key: "Idle",
            frames: frames
        });
}

/**
 * 
 * @param {Phaser.Animations.AnimationManager} animationManager 
 * @param {string} texture 
 * @param {string} key 
 * @param {number[]} animationData 
 */
function createAnimation(animationManager, texture, key, animationData) {
    let frames = [];
    animationData.forEach(frameNum => frames.push({ frame: frameNum.toString() }));

    animationManager.create(
        {
            defaultTextureKey: texture,
            frameRate: 24,
            key: key,
            frames: frames
        });
}

const ChestShut12AnimationData = {
    frames: [
        [0, 0, 256, 128, 0, -1, -5],
        [256, 0, 256, 128, 0, -1, -5],
        [512, 0, 256, 128, 0, -1, -5],
        [768, 0, 256, 128, 0, -1, -5],
        [1024, 0, 256, 128, 0, -1, -5],
        [1280, 0, 256, 128, 0, -1, -5],
        [1536, 0, 256, 128, 0, -1, -5],
        [0, 128, 256, 128, 0, -1, -5],
        [256, 128, 256, 128, 0, -1, -5],
        [512, 128, 256, 128, 0, -1, -5],
        [768, 128, 256, 128, 0, -1, -5],
        [1024, 128, 256, 128, 0, -1, -5],
        [1280, 128, 256, 128, 0, -1, -5],
        [1536, 128, 256, 128, 0, -1, -5],
        [0, 256, 256, 128, 0, -1, -5],
        [256, 256, 256, 128, 0, -1, -5],
        [512, 256, 256, 128, 0, -1, -5],
        [768, 256, 256, 128, 0, -1, -5],
        [1024, 256, 256, 128, 0, -1, -5],
        [1280, 256, 256, 128, 0, -1, -5],
        [1536, 256, 256, 128, 0, -1, -5],
        [0, 384, 256, 128, 0, -1, -5],
        [256, 384, 256, 128, 0, -1, -5],
        [512, 384, 256, 128, 0, -1, -5],
        [768, 384, 256, 128, 0, -1, -5],
        [1024, 384, 256, 128, 0, -1, -5],
        [1280, 384, 256, 128, 0, -1, -5],
        [1536, 384, 256, 128, 0, -1, -5],
        [0, 512, 256, 128, 0, -1, -5],
        [256, 512, 256, 128, 0, -1, -5],
        [512, 512, 256, 128, 0, -1, -5],
        [768, 512, 256, 128, 0, -1, -5],
        [1024, 512, 256, 128, 0, -1, -5]
    ],
    animations: {
        Shut: {
            frames: [
                1,
                2,
                3,
                4,
                4,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                31,
                30,
                29,
                28,
                27
            ],
            "next": "Idle",
            "frequency": 0,
            "speed": 1
        },
        Idle: { frames: [27], "speed": 1 }
    }
}

const ChestShut34AnimationData = {
    frames: [
        [0, 0, 256, 128, 0, -1, -5],
        [256, 0, 256, 128, 0, -1, -5],
        [512, 0, 256, 128, 0, -1, -5],
        [768, 0, 256, 128, 0, -1, -5],
        [1024, 0, 256, 128, 0, -1, -5],
        [1280, 0, 256, 128, 0, -1, -5],
        [1536, 0, 256, 128, 0, -1, -5],
        [0, 128, 256, 128, 0, -1, -5],
        [256, 128, 256, 128, 0, -1, -5],
        [512, 128, 256, 128, 0, -1, -5],
        [768, 128, 256, 128, 0, -1, -5],
        [1024, 128, 256, 128, 0, -1, -5],
        [1280, 128, 256, 128, 0, -1, -5],
        [1536, 128, 256, 128, 0, -1, -5],
        [0, 256, 256, 128, 0, -1, -5],
        [256, 256, 256, 128, 0, -1, -5],
        [512, 256, 256, 128, 0, -1, -5],
        [768, 256, 256, 128, 0, -1, -5],
        [1024, 256, 256, 128, 0, -1, -5],
        [1280, 256, 256, 128, 0, -1, -5],
        [1536, 256, 256, 128, 0, -1, -5],
        [0, 384, 256, 128, 0, -1, -5],
        [256, 384, 256, 128, 0, -1, -5],
        [512, 384, 256, 128, 0, -1, -5],
        [768, 384, 256, 128, 0, -1, -5],
        [1024, 384, 256, 128, 0, -1, -5],
        [1280, 384, 256, 128, 0, -1, -5],
        [1536, 384, 256, 128, 0, -1, -5],
        [0, 512, 256, 128, 0, -1, -5],
        [256, 512, 256, 128, 0, -1, -5],
        [512, 512, 256, 128, 0, -1, -5],
        [768, 512, 256, 128, 0, -1, -5],
        [1024, 512, 256, 128, 0, -1, -5]
    ],
    animations: {
        Shut: {
            frames: [
                1,
                2,
                3,
                4,
                4,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                31,
                30,
                29,
                28,
                27
            ],
            "speed": 1,
            "next": "Idle"
        },
        Idle: { frames: [27], "speed": 1 }
    }
}

const ChestShut5AnimationData = {
    frames: [
        [0, 0, 256, 128, 0, 0, -5],
        [256, 0, 256, 128, 0, 0, -5],
        [512, 0, 256, 128, 0, 0, -5],
        [768, 0, 256, 128, 0, 0, -5],
        [1024, 0, 256, 128, 0, 0, -5],
        [1280, 0, 256, 128, 0, 0, -5],
        [1536, 0, 256, 128, 0, 0, -5],
        [0, 128, 256, 128, 0, 0, -5],
        [256, 128, 256, 128, 0, 0, -5],
        [512, 128, 256, 128, 0, 0, -5],
        [768, 128, 256, 128, 0, 0, -5],
        [1024, 128, 256, 128, 0, 0, -5],
        [1280, 128, 256, 128, 0, 0, -5],
        [1536, 128, 256, 128, 0, 0, -5],
        [0, 256, 256, 128, 0, 0, -5],
        [256, 256, 256, 128, 0, 0, -5],
        [512, 256, 256, 128, 0, 0, -5],
        [768, 256, 256, 128, 0, 0, -5],
        [1024, 256, 256, 128, 0, 0, -5],
        [1280, 256, 256, 128, 0, 0, -5],
        [1536, 256, 256, 128, 0, 0, -5],
        [0, 384, 256, 128, 0, 0, -5],
        [256, 384, 256, 128, 0, 0, -5],
        [512, 384, 256, 128, 0, 0, -5],
        [768, 384, 256, 128, 0, 0, -5],
        [1024, 384, 256, 128, 0, 0, -5],
        [1280, 384, 256, 128, 0, 0, -5],
        [1536, 384, 256, 128, 0, 0, -5],
        [0, 512, 256, 128, 0, 0, -5],
        [256, 512, 256, 128, 0, 0, -5],
        [512, 512, 256, 128, 0, 0, -5],
        [768, 512, 256, 128, 0, 0, -5]
    ],
    animations: {
        Shut: {
            frames: [
                0,
                1,
                2,
                3,
                3,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                30,
                29,
                28,
                27,
                26
            ],
            "speed": 1,
            "next": "Idle"
        },
        Idle: { frames: [27], "speed": 1 }
    }
}

const ChestShut6AnimationData = {
    frames: [
        [0, 0, 256, 128, 0, -1, -5],
        [256, 0, 256, 128, 0, -1, -5],
        [512, 0, 256, 128, 0, -1, -5],
        [768, 0, 256, 128, 0, -1, -5],
        [1024, 0, 256, 128, 0, -1, -5],
        [1280, 0, 256, 128, 0, -1, -5],
        [1536, 0, 256, 128, 0, -1, -5],
        [0, 128, 256, 128, 0, -1, -5],
        [256, 128, 256, 128, 0, -1, -5],
        [512, 128, 256, 128, 0, -1, -5],
        [768, 128, 256, 128, 0, -1, -5],
        [1024, 128, 256, 128, 0, -1, -5],
        [1280, 128, 256, 128, 0, -1, -5],
        [1536, 128, 256, 128, 0, -1, -5],
        [0, 256, 256, 128, 0, -1, -5],
        [256, 256, 256, 128, 0, -1, -5],
        [512, 256, 256, 128, 0, -1, -5],
        [768, 256, 256, 128, 0, -1, -5],
        [1024, 256, 256, 128, 0, -1, -5],
        [1280, 256, 256, 128, 0, -1, -5],
        [1536, 256, 256, 128, 0, -1, -5],
        [0, 384, 256, 128, 0, -1, -5],
        [256, 384, 256, 128, 0, -1, -5],
        [512, 384, 256, 128, 0, -1, -5],
        [768, 384, 256, 128, 0, -1, -5],
        [1024, 384, 256, 128, 0, -1, -5],
        [1280, 384, 256, 128, 0, -1, -5],
        [1536, 384, 256, 128, 0, -1, -5],
        [0, 512, 256, 128, 0, -1, -5],
        [256, 512, 256, 128, 0, -1, -5],
        [512, 512, 256, 128, 0, -1, -5],
        [768, 512, 256, 128, 0, -1, -5]
    ],
    animations: {
        Shut: {
            frames: [
                0,
                1,
                2,
                3,
                3,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                30,
                29,
                28,
                27,
                26
            ],
            "speed": 1,
            "next": "Idle"
        },
        Idle: { frames: [27], "speed": 1 }
    }
}

const ChestShut78AnimationData = {
    frames: [
        [0, 0, 256, 128, 0, -1, -5],
        [256, 0, 256, 128, 0, -1, -5],
        [512, 0, 256, 128, 0, -1, -5],
        [768, 0, 256, 128, 0, -1, -5],
        [1024, 0, 256, 128, 0, -1, -5],
        [1280, 0, 256, 128, 0, -1, -5],
        [1536, 0, 256, 128, 0, -1, -5],
        [0, 128, 256, 128, 0, -1, -5],
        [256, 128, 256, 128, 0, -1, -5],
        [512, 128, 256, 128, 0, -1, -5],
        [768, 128, 256, 128, 0, -1, -5],
        [1024, 128, 256, 128, 0, -1, -5],
        [1280, 128, 256, 128, 0, -1, -5],
        [1536, 128, 256, 128, 0, -1, -5],
        [0, 256, 256, 128, 0, -1, -5],
        [256, 256, 256, 128, 0, -1, -5],
        [512, 256, 256, 128, 0, -1, -5],
        [768, 256, 256, 128, 0, -1, -5],
        [1024, 256, 256, 128, 0, -1, -5],
        [1280, 256, 256, 128, 0, -1, -5],
        [1536, 256, 256, 128, 0, -1, -5],
        [0, 384, 256, 128, 0, -1, -5],
        [256, 384, 256, 128, 0, -1, -5],
        [512, 384, 256, 128, 0, -1, -5],
        [768, 384, 256, 128, 0, -1, -5],
        [1024, 384, 256, 128, 0, -1, -5],
        [1280, 384, 256, 128, 0, -1, -5],
        [1536, 384, 256, 128, 0, -1, -5],
        [0, 512, 256, 128, 0, -1, -5],
        [256, 512, 256, 128, 0, -1, -5],
        [512, 512, 256, 128, 0, -1, -5],
        [768, 512, 256, 128, 0, -1, -5],
        [1024, 512, 256, 128, 0, -1, -5]
    ],
    animations: {
        Shut: {
            frames: [
                1,
                2,
                3,
                4,
                4,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                31,
                30,
                29,
                28,
                27
            ],
            "speed": 1,
            "next": "Idle"
        },
        Idle: { frames: [27], "speed": 1 }
    }
}

const ChestShut910AnimationData = {
    frames: [
        [0, 0, 256, 128, 0, -1, -5],
        [256, 0, 256, 128, 0, -1, -5],
        [512, 0, 256, 128, 0, -1, -5],
        [768, 0, 256, 128, 0, -1, -5],
        [1024, 0, 256, 128, 0, -1, -5],
        [1280, 0, 256, 128, 0, -1, -5],
        [1536, 0, 256, 128, 0, -1, -5],
        [0, 128, 256, 128, 0, -1, -5],
        [256, 128, 256, 128, 0, -1, -5],
        [512, 128, 256, 128, 0, -1, -5],
        [768, 128, 256, 128, 0, -1, -5],
        [1024, 128, 256, 128, 0, -1, -5],
        [1280, 128, 256, 128, 0, -1, -5],
        [1536, 128, 256, 128, 0, -1, -5],
        [0, 256, 256, 128, 0, -1, -5],
        [256, 256, 256, 128, 0, -1, -5],
        [512, 256, 256, 128, 0, -1, -5],
        [768, 256, 256, 128, 0, -1, -5],
        [1024, 256, 256, 128, 0, -1, -5],
        [1280, 256, 256, 128, 0, -1, -5],
        [1536, 256, 256, 128, 0, -1, -5],
        [0, 384, 256, 128, 0, -1, -5],
        [256, 384, 256, 128, 0, -1, -5],
        [512, 384, 256, 128, 0, -1, -5],
        [768, 384, 256, 128, 0, -1, -5],
        [1024, 384, 256, 128, 0, -1, -5],
        [1280, 384, 256, 128, 0, -1, -5],
        [1536, 384, 256, 128, 0, -1, -5],
        [0, 512, 256, 128, 0, -1, -5],
        [256, 512, 256, 128, 0, -1, -5],
        [512, 512, 256, 128, 0, -1, -5],
        [768, 512, 256, 128, 0, -1, -5],
        [1024, 512, 256, 128, 0, -1, -5]
    ],
    animations: {
        Shut: {
            frames: [
                1,
                2,
                3,
                4,
                4,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                31,
                30,
                29,
                28,
                27
            ],
            "speed": 1,
            "next": "Idle"
        },
        Idle: { frames: [27], "speed": 1 }
    }
}

const SharkAnimationData = {
    frames: [
        [0, 0, 128, 256, 0, 0, 0],
        [128, 0, 128, 256, 0, 0, 0],
        [256, 0, 128, 256, 0, 0, 0],
        [384, 0, 128, 256, 0, 0, 0],
        [512, 0, 128, 256, 0, 0, 0],
        [640, 0, 128, 256, 0, 0, 0],
        [768, 0, 128, 256, 0, 0, 0],
        [896, 0, 128, 256, 0, 0, 0]
    ],
    animations: {
        Bite: { frames: [0, 1, 2, 3, 4, 5, 6, 7, 0, 1, 2, 3, 4, 5, 6, 7, 0, 1, 2, 3, 4, 5, 6, 7], "next": "Idle", "frequency": 1, "speed": 1 },
        Idle: { frames: [7], "speed": 1 }
    }
}